import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { I18n } from 'react-i18next';

import { Steps, Step } from '..';

/**
 * Dropdown
 *
 * This component is in charge of displaying
 * a stepBar
 *
 * @return {jsx}
 */

export class Dropdown extends PureComponent {
  render() {
    const { step, className, hostRef } = this.props;

    return (
      <div ref={hostRef} className={className}>
        <I18n ns={['translations']}>
          {t => (
            <Steps current={step.current}>
              <Step url="/informations">
                <span> {t('navigation.informations')}</span>
              </Step>
              <Step url="/order">
                <span> {t('navigation.order')}</span>
              </Step>
              <Step url="/delivery">
                <span> {t('navigation.delivery')}</span>
              </Step>
              <Step url="/training">
                <span> {t('navigation.training')}</span>
              </Step>
            </Steps>
          )}
        </I18n>
      </div>
    );
  }
}

/**
 * PropTypes Validation
 */
const { func, string, object } = PropTypes;
Dropdown.propTypes = {
  step: object.isRequired,
  hostRef: func,
  className: string,
};

/**
 * Default Props
 */
Dropdown.defaultProps = {
  className: '',
  hostRef: () => {},
};

/** Defines the mapping Redux store to props. */
const mapStateToProps = ({ step }) => {
  return {
    step,
  };
};

const DropdownConnect = connect(mapStateToProps)(styled(Dropdown)`
  position: absolute;
  top: calc(100% + 1px);
  width: 100%;
  background-color: ${({ theme: { palette } }) => palette.white};
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  transform-origin: 50% 0%;
`);

export default DropdownConnect;



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js